import styled from 'styled-components'
import { SPACING } from '../../../styles/theme'

/**
 * Styled components for MindMapFlow
 * Replaces inline styles with theme-based styled components
 */

// Loading container - centered with gap
export const LoadingContainer = styled.div`
  height: calc(100dvh - 64px);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: ${SPACING.lg};
`

// Main layout container - full viewport minus header
export const MainLayoutContainer = styled.div`
  display: flex;
  height: calc(100dvh - 64px);
`

// Content wrapper - full height with flex column
export const ContentWrapper = styled.div`
  height: calc(100dvh - 64px);
  width: 100%;
  display: flex;
  flex-direction: column;
  flex: 1;
`

// Inner content container - flex with relative positioning and overflow hidden
export const InnerContentContainer = styled.div`
  flex: 1;
  display: flex;
  position: relative;
  overflow: hidden;
`

// ReactFlow container wrapper - flex with relative positioning and minWidth
export const ReactFlowWrapper = styled.div`
  flex: 1;
  position: relative;
  min-width: 0;

  /* Disable edge interactivity */
  .react-flow__edge {
    pointer-events: none;
    cursor: default;
  }

  /* Branch selection mode: shared styles for both selected and unselected nodes */
  .react-flow__node.branch-selected,
  .react-flow__node.branch-unselected {
    cursor: pointer !important;
    transition: opacity 0.2s ease;

    /* Disable all inner interaction so clicks reach the React Flow wrapper.
       Without this, BaseNode's stopPropagation prevents onNodeClick from firing
       because XYDrag (React Flow's normal click path) is destroyed in read-only mode. */
    & > * {
      pointer-events: none;
    }
  }

  .react-flow__node.branch-selected {
    opacity: 1;
  }

  .react-flow__node.branch-unselected {
    opacity: 0.35;
  }
`
